'use strict';

import L from 'external/leaflet';
import 'external/leaflet.markercluster';
import 'external/css!leaflet.markercluster-css'; //TODO Needed?
import 'external/css!leaflet.markercluster-default-css'; //TODO Needed?

const FliwasDataLayer = L.FeatureGroup.extend({

    options: {
        cluster: true,
        markerOptions: {},
        clusterOptions: {},
        bubblingMouseEvents: true,
        markersInheritOptions: true,
    },

    initialize: function (options = {}){
        L.FeatureGroup.prototype.initialize.call(this, null, options);
        this._clusterGroup = L.markerClusterGroup({ ...this.options.clusterOptions, bubblingMouseEvents: true });
        this._layerGroup = L.featureGroup({ bubblingMouseEvents: true });
    },

    shouldCluster: function (layer){
        return this.options.cluster && !layer.preventCluster;
    },

    addLayers: function (layers){
        const a = [], aC = [];

        layers.forEach(l => {
            l.addEventParent(this);
            this._layers[this.getLayerId(l)] = l;
            (this.shouldCluster(l) ? aC : a).push(l);
        });

        if (this._map) {
            aC.length === 1 ? this._clusterGroup.addLayer(aC[0]) : this._clusterGroup.addLayers(aC);
            a.forEach(l => this._layerGroup.addLayer(l));
        }

        return this.fire('layeradd', { layers });
    },

    addLayer: function (layer){
        if (this.hasLayer(layer)) {
            return this;
        }

        layer.addEventParent(this);
        this._layers[this.getLayerId(layer)] = layer;

        if (this._map) {
            (this.shouldCluster(layer) ? this._clusterGroup : this._layerGroup)
                .addLayer(layer);
        }

        return this.fire('layeradd', { layer: layer });
    },

    removeLayers: function (layers){
        const r = [], rC = [];

        layers.forEach(l => {
            l.removeEventParent(this);
            delete this._layers[this.getLayerId(l)];
            (this._layerGroup.hasLayer(l) ? r : rC).push(l);
        });

        if (this._map) {
            this._clusterGroup.removeLayers(rC);
            r.forEach(l => this._layerGroup.removeLayer(l));
        }

        return this.fire('layerremove', { layers });
    },

    removeLayer: function (layer){
        if (!this.hasLayer(layer)) {
            return this;
        }

        layer.removeEventParent(this);
        delete this._layers[this.getLayerId(layer)];

        if (this._map) {
            if (this._layerGroup.hasLayer(layer)) {
                this._layerGroup.removeLayer(layer);
            } else {
                this._clusterGroup.removeLayer(layer);
            }
        }
        return this.fire('layerremove', { layer });
    },

    onAdd: function (map){
        const a = [], aC = [];
        this._map = map;
        this._layerGroup.addTo(map);
        this._clusterGroup.addTo(map);

        this.getLayers().forEach(l => (this.shouldCluster(l) ? aC : a).push(l));

        this._clusterGroup.addLayers(aC);
        a.forEach(l => this._layerGroup.addLayer(l));
    },

    onRemove: function (map){
        const r = [], rC = [];
        this._map = null;
        map.removeLayer(this._layerGroup);
        map.removeLayer(this._clusterGroup);

        this.getLayers().forEach(l => (this._layerGroup.hasLayer(l) ? r : rC).push(l));

        this._clusterGroup.removeLayers(rC);
        r.forEach(l => this._layerGroup.removeLayer(l));
    },

    getBounds: function (){
        return new L.LatLngBounds().extend(this._clusterGroup.getBounds()).extend(this._layerGroup.getBounds());
    }

});

export default FliwasDataLayer;



// WEBPACK FOOTER //
// ./js/layer/FliwasDataLayer.js